import { colors } from './colors';

export const theme = {
  colors,
  font: {
    thin: 300,
    regular: 400,
    bold: 700,
  },
  media: {
    phone: '@media (min-width: 320px)',
    tablet: '@media (min-width: 728px)',
    laptop: '@media (min-width: 1024px)',
    desktop: '@media (min-width: 1280px)'
  }
}